import folder from './folder'

export default [...folder]
